import http from "../../helpers/http";
import httpBlob from "../../helpers/http-blob";
import * as helpers from "../../helpers/helpers";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_GUIDANCE,
  FETCH_GUIDANCE_SUCCESS,
  FETCH_GUIDANCE_FAILED,
} from "./actionTypes";
import { getAuthUserToken } from "../../helpers/authToken";

export const fetchGuidance = (slug) => (dispatch) => {
  dispatch({
    type: FETCH_GUIDANCE,
    payload: null,
  });
  http
    .post(
      "user/fetch-guidance",
      helpers.doObjToFormData({
        token: getAuthUserToken(),
        slug: slug,
      }),
    )
    .then(({ data }) => {
      dispatch({
        type: FETCH_GUIDANCE_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_GUIDANCE_FAILED,
        payload: error,
      });
      const { data } = error.response;
      localStorage.removeItem("authToken");
      window.location.reload();
    });
};
